module.exports = __webpack_public_path__ + "media/images/flags/64/Republic-of-the-Congo-9db5d1668de2071543e046ff5588c7e0.png";